// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badesul-society-modal {
  display: flex;
  row-gap: 1rem !important;
  width: 100%;
  padding: 1rem;
}
.badesul-society-modal .ant-modal-content {
  width: 100%;
}
.badesul-society-modal label {
  color: black !important;
}
.badesul-society-modal .ant-select-selector {
  padding: 1 0.5 1 1rem !important;
  height: 3.5rem !important;
  border-radius: 1.25rem !important;
}
.badesul-society-modal .ant-select-selector:hover,
.badesul-society-modal .ant-select-selector:active {
  border-color: var(--primary-button-color) !important;
}
.badesul-society-modal .ant-select-selector span {
  display: flex;
  height: 100%;
  align-items: center;
}
.badesul-society-form,
.badesul-society-item {
  width: 100%;
  padding: 1rem;
}
.badesul-society-form .buttons,
.badesul-society-item .buttons {
  display: flex;
}
.badesul-society-form p,
.badesul-society-item p {
  margin: 0px;
}
.badesul-society-form .badesul-society-item-label,
.badesul-society-item .badesul-society-item-label {
  font-weight: 500;
}
.badesul-society-form .gyramais-btn,
.badesul-society-item .gyramais-btn {
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/screens/BusinessBadesulMicrocreditoRegisterScreen/components/BadesulMicrocreditoBusinessUserDrawer/components/society.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,wBAAA;EAIA,WAAA;EACA,aAAA;AAFF;AALA;EAII,WAAA;AAIJ;AARA;EASI,uBAAA;AAEJ;AAXA;EAYI,gCAAA;EACA,yBAAA;EACA,iCAAA;AAEJ;AADI;;EAEE,oDAAA;AAGN;AApBA;EAoBM,aAAA;EACA,YAAA;EACA,mBAAA;AAGN;AAEA;;EAEE,WAAA;EACA,aAAA;AAAF;AAHA;;EAKI,aAAA;AAEJ;AAPA;;EAQI,WAAA;AAGJ;AAXA;;EAWI,gBAAA;AAIJ;AAfA;;EAcI,mBAAA;AAKJ","sourcesContent":[".badesul-society-modal {\n  display: flex;\n  row-gap: 1rem !important;\n  .ant-modal-content {\n    width: 100%;\n  }\n  width: 100%;\n  padding: 1rem;\n  label {\n    color: black !important;\n  }\n  .ant-select-selector {\n    padding: 1 0.5 1 1rem !important;\n    height: 3.5rem !important;\n    border-radius: 1.25rem !important;\n    &:hover,\n    &:active {\n      border-color: var(--primary-button-color) !important;\n    }\n    span {\n      display: flex;\n      height: 100%;\n      align-items: center;\n    }\n  }\n}\n\n.badesul-society-form,\n.badesul-society-item {\n  width: 100%;\n  padding: 1rem;\n  .buttons {\n    display: flex;\n  }\n  p {\n    margin: 0px;\n  }\n  .badesul-society-item-label {\n    font-weight: 500;\n  }\n  .gyramais-btn {\n    margin-bottom: 1rem;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
